import { useEffect, useState } from 'react';

// Get the actual height on iOS Safari
function getHeight() {
  const isIOS = navigator?.userAgent.match(/iphone|ipod|ipad/i);

  if (!isIOS) return window.innerHeight;

  // Measure a 100vh ruler, conscientious of device orientation
  const ruler = document.createElement('div');
  ruler.style.position = 'fixed';
  ruler.style.height = '100vh';
  ruler.style.width = 0;
  ruler.style.top = 0;

  document.documentElement.appendChild(ruler);
  const height = ruler.offsetHeight;
  document.documentElement.removeChild(ruler);

  return height;
}

export function useWindowSize() {
  const [windowSize, setWindowSize] = useState({ width: 1280, height: 800 });

  useEffect(() => {
    const handleResize = () => {
      setWindowSize({ width: window.innerWidth, height: getHeight() });
    };

    window.addEventListener('resize', handleResize);
    handleResize();

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return windowSize;
}
